import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Page-view tracking for Google Analytics 4.
 *
 * Set REACT_APP_GA_MEASUREMENT_ID to a GA4 id (looks like "G-XXXXXXXXXX").
 * With no id set, this does nothing at all — no script is loaded and no
 * requests are made, which is the right default for local development.
 */
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function initAnalytics() {
  if (initialized || !MEASUREMENT_ID || typeof window === 'undefined') return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  // Routes are tracked below, so let this send nothing on load.
  gtag('config', MEASUREMENT_ID, { send_page_view: false });
}

const withTracker = (WrappedComponent, options = {}) => {
  return function TrackedComponent(props) {
    const location = useLocation();

    useEffect(() => {
      if (!MEASUREMENT_ID) return;
      initAnalytics();
      gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
        ...options,
      });
    }, [location.pathname, location.search]);

    return <WrappedComponent {...props} />;
  };
};

export default withTracker;
